module.exports = __webpack_public_path__ + "static/carousel-5-497afe516d33a5b40db348648d3e8608.png";